var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgMarketingFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 2.5V11.875C3.125 12.9105 3.96447 13.75 5 13.75H6.875M3.125 2.5H1.875M3.125 2.5H16.875M16.875 2.5H18.125M16.875 2.5V11.875C16.875 12.9105 16.0355 13.75 15 13.75H13.125M6.875 13.75H13.125M6.875 13.75L6.04167 16.25M13.125 13.75L13.9583 16.25M13.9583 16.25L14.375 17.5M13.9583 16.25H6.04167M6.04167 16.25L5.625 17.5M7.5 9.375V10.625M10 7.5V10.625M12.5 5.625V10.625",
    stroke: "#216AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgMarketingFocus);
export default __webpack_public_path__ + "static/media/svg_marketing_focus.fa26da804fec6d06bab00ce3d9e351eb.svg";
export { ForwardRef as ReactComponent };